import React, { useEffect, Suspense, useState } from 'react'
import { Canvas, useLoader } from 'react-three-fiber'
// import * as THREE from 'three'
import { OrbitControls, useGLTF } from '@react-three/drei'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js'

// components
import { Face } from '../components/Three/Face'
import BoxShape from '../components/BoxShape'
import SphereShape from '../components/SphereShape'
import PlanShape from '../components/PlanShape'
import HtmlContent from '../components/HtmlContent'
import MyName from '../components/MyName'
import Alien from '../components/Alien'

const Scene = ({ showFaces, setShowFaces }) => {
  const [showSphere, setShowSphere] = useState(
    window.location.pathname.length === 1
  )
  const [followMouse, setFollowMouse] = useState(null)

  const [
    earth,
    mercury,
    moon,
    sun,
    space,
    venus,
    black_hole,
    space_time,
    bashar,
    chiangmai,
  ] = useLoader(TextureLoader, [
    'images/earth.jpg',
    'images/mercury.jpg',
    'images/moon.jpg',
    'images/sun.jpg',
    'images/space.jpg',
    'images/venus.jpg',
    'images/black_hole_1.gif',
    'images/space_time.jpg',
    'images/bashar.jpg',
    'images/in_chiangmai.jpg',
  ])

  useEffect(() => {
    setShowSphere(window?.location?.pathname?.length === 1)
  }, [window?.location?.pathname?.length])

  return (
    <div onMouseMove={e => setFollowMouse(e)} className='scene'>
      <Canvas linear flat shadows camera={{ position: [-5, 2, 20], fov: 30 }}>
        {/* this will add fogy effect on canvas */}
        {/* <fog attach="fog" args={['red', 1, 5]} /> */}
        <Suspense fallback={null}>
          <ambientLight intensity={0.5} />
          <directionalLight
            castShadow
            position={[0, 10, 0]}
            intensity={1.5}
            shadow-mapSize={[1024, 1024]}
            shadow-camera-far={50}
            shadow-camera-left={-10}
            shadow-camera-right={10}
            shadow-camera-top={10}
            shadow-camera-bottom={-10}
          />
          <pointLight position={[-15, 4, -40]} intensity={2} />
          <group>
            {showSphere && (
              <>
                <SphereShape
                  position={[-1, 3, 0]}
                  speed={2}
                  factor={1}
                  args={[1, 50, 50, 5]}
                  scale={[2, 2, 2]}
                  cover={sun}
                  delay='5'
                />
                <SphereShape
                  position={[-3, 4, 3]}
                  speed={2}
                  factor={1}
                  args={[1, 50, 50, 5]}
                  cover={mercury}
                  animation
                  delay='0'
                />
                <SphereShape
                  position={[-2, 4, 5]}
                  speed={2}
                  factor={1}
                  args={[1, 50, 50, 5]}
                  scale={[0.7, 0.7, 0.7]}
                  cover={venus}
                  animation
                  delay='1'
                />
                <SphereShape
                  position={[-1, 2, 6]}
                  speed={2}
                  factor={1}
                  cover={earth}
                  args={[1, 50, 50, 5]}
                  animation
                  delay='2'
                />
                <SphereShape
                  position={[-3, 0, 7]}
                  speed={2}
                  factor={1}
                  args={[1, 50, 50, 5]}
                  scale={[0.2, 0.2, 0.2]}
                  cover={moon}
                  animation
                  delay='2'
                />
              </>
            )}
            <BoxShape
              position={[2, 4, 2]}
              color='blue'
              speed={1}
              factor={0.7}
              args={[2, 2, 2]}
              cover={{ bashar }}
            />
            <PlanShape
              args={[500, 500]}
              position={[1, -3.5, -1]}
              cover={space}
            />
            {showFaces && <Face />}
            <MyName position={[-3.5, -1.2, 10]} children='Bashar' />
            <MyName
              color='#7cb342'
              position={[-1.6, -1.4, 10]}
              children='Alwarad'
            />
            <HtmlContent showFaces={showFaces} setShowFaces={setShowFaces} />
          </group>
          <OrbitControls />
        </Suspense>
      </Canvas>
      <Alien followMouse={followMouse} />
    </div>
  )
}

export default Scene
